<div class="login-body">

  <div class="flex-row tw:h-screen" id="login">
    <div class="flex-column"></div>

    <div class="flex-column-main">

      <div class="content-wrapper">

        <app-login-brand></app-login-brand>

        <form name="form" (ngSubmit)="f.form.valid && login()" #f="ngForm" novalidate>
          <div class="form-group" [ngClass]="{ 'has-error': f.submitted && !username.valid }">
            <input type="text" class="form-control" placeholder="Username" name="username"
              [(ngModel)]="model.username" #username="ngModel" required />
              @if (f.submitted && !username.valid) {
                <div>Username is required</div>
              }
            </div>
            <div class="form-group" [ngClass]="{ 'has-error': f.submitted && !password.valid }">
              <input type="password" class="form-control" placeholder="Password" name="password"
                [(ngModel)]="model.password" #password="ngModel" required />
                @if (f.submitted && !password.valid) {
                  <div>Password is required</div>
                }
              </div>
              <div class="form-group" [ngClass]="{ 'has-error': f.submitted && !code.valid }">
                <input type="text" class="form-control" placeholder="Code" name="code"
                  [(ngModel)]="model.code" #code="ngModel" required />
                  @if (f.submitted && !code.valid) {
                    <div>Code is required</div>
                  }
                </div>
                <div class="form-group">
                  <button class="btn-outline-light btn-lg" type="submit">Sign In</button>
                </div>

                <div class="form-group hidden">
                  <input type="checkbox" id="robotCheck" name="robotCheck" value="NotRobot">
                  <label for="robotCheck"> I am not a robot?</label>
                </div>

              </form>

              <div class="push"></div>

            </div>
          </div>

          <div class="flex-column"></div>
        </div>
      </div>